import React from "react";
import { statusClasses, priorityClasses, approvalClasses } from "@/lib/ui";

export function Chip({ children, className = "", testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider rounded-sm border ${className}`}
    >
      {children}
    </span>
  );
}

export function StatusBadge({ status }) {
  return <Chip className={statusClasses(status)}>{status || "—"}</Chip>;
}

export function PriorityBadge({ priority }) {
  return <Chip className={priorityClasses(priority)}>{priority || "—"}</Chip>;
}

export function ApprovalBadge({ status }) {
  return <Chip className={approvalClasses(status)}>{status || "—"}</Chip>;
}

export function SectionLabel({ children }) {
  return (
    <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-500">
      {children}
    </div>
  );
}

export function Pipeline({ steps, testId }) {
  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-2">
      {steps.map((s, i) => (
        <React.Fragment key={s}>
          <span className="text-xs font-mono uppercase tracking-wider text-zinc-400 border border-white/10 bg-white/[0.03] px-2.5 py-1 rounded-sm">
            {s}
          </span>
          {i < steps.length - 1 && <span className="text-zinc-700">→</span>}
        </React.Fragment>
      ))}
    </div>
  );
}

export function ProgressBar({ value }) {
  const v = Math.max(0, Math.min(100, value || 0));
  return (
    <div className="w-full h-1.5 bg-white/10 rounded-sm overflow-hidden">
      <div
        className="h-full bg-white transition-all duration-500"
        style={{ width: `${v}%` }}
      />
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center das-grid rounded-sm border border-white/10 bg-[#0a0a0a]">
      {Icon && <Icon size={32} className="text-zinc-600 mb-3" />}
      <p className="text-zinc-300 font-medium">{title}</p>
      {hint && <p className="text-sm text-zinc-500 mt-1">{hint}</p>}
    </div>
  );
}
